import { render, staticRenderFns } from "./login-header.vue?vue&type=template&id=7bcdf4e2&scoped=true&"
import script from "./login-header.vue?vue&type=script&lang=js&"
export * from "./login-header.vue?vue&type=script&lang=js&"
import style0 from "./login-header.vue?vue&type=style&index=0&id=7bcdf4e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcdf4e2",
  null
  
)

export default component.exports